// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"cb_a bhc_h bhc_ka bhc_ux bhc_ro bhc_un bhc_rq bhc_rh"};